/**
 * Early-bird launch pricing deadline: 15 August 2026, 9am UK time. Passed; the
 * only remaining consumer is the usage-nudge upsell email, which reads the
 * backend's own mirror of EARLY_BIRD_DEADLINE_ISO in
 * packages/backend/convex/utils/board.ts.
 */
export const EARLY_BIRD_DEADLINE_ISO = "2026-08-15T09:00:00+01:00";

export const EARLY_BIRD_DEADLINE = new Date(EARLY_BIRD_DEADLINE_ISO);

/**
 * Back to school sale deadline: end of 30 September 2026, UK time. Single
 * source of truth for the top-of-page sale strip (apps/web/lib/sale) and the
 * sign-in announcement's expiry. The Convex backend can't import this package
 * into its bundle, so it mirrors SALE_DEADLINE_ISO in
 * packages/backend/convex/utils/board.ts. Keep the two in sync.
 */
export const SALE_DEADLINE_ISO = "2026-09-30T23:59:59+01:00";

export const SALE_DEADLINE = new Date(SALE_DEADLINE_ISO);
